import React,{useRef} from 'react';
import '../../assets/styles/LandingPath.css';

import LandingPathHCLTechLogo from '../../assets/images/23.svg';
import LandingPathCareerShaperLogo from '../../assets/images/user.svg';
import LandingPathPearsonLogo from '../../assets/images/Rupee.svg';
import LandingPathMeityLogo from '../../assets/images/Group (1).svg';
import LandingPathContentsBorderImage from '../../assets/images/ARISE WEBSITE_microsite-18.png';
import bulb from '../../assets/images/Vector.svg'
import LandingHeader from '../header/LandingHeader';
import WhoShouldEnroll from './WhoShouldEnroll';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import HowItWorks from './HowItWorks';
import PoweredBy from './PoweredBy';
import Timer from './Timer';
import LandingInternship from './LandingInternship';
import LandingFAQ from './LandingFAQ';
import LandingFooter from '../footer/LandingFooter';
import LandingPage from './LandingPage';


const LandingPath = () => {

       const formRef = useRef(null);
    
    
        const scrollToForm = () => {
            if (formRef.current) {
                const top = formRef.current.getBoundingClientRect().top + window.pageYOffset - 80; // adjust offset (e.g. 80px for sticky header height)
                window.scrollTo({ top, behavior: "smooth" });
            }
        };
    return (
   <>
     <LandingHeader />
        <section className='landing-path-section'>
            <div className='landing-path-container pt-5'>
                <div className='landing-path-title-box text-center'>
                    <h2 className='landing-path-title'>Your Path to a ₹ 10,00,000 Grant</h2>
                    <div className='landing-path-border-image-box'>
                        <img 
                            src={LandingPathContentsBorderImage} 
                            alt='Contents Border' 
                            className='landing-path-border-image' 
                        />
                    </div>
                </div>

                <div className='landing-path-carousel d-flex justify-content-center flex-wrap mt-4'>
                    <div className='landing-path-card'>
                        <img src={LandingPathHCLTechLogo} alt='HCLTech Logo' className='landing-path-logo' />
                        <h3>Learn & Get Certified</h3>
                        <p>Unlock your potential with expert-led courses</p>
                    </div>


                      <div className='landing-path-card'>
                        <img src={LandingPathCareerShaperLogo} alt='Career Shaper Logo' className='landing-path-logo' />
                        <h3>Guidance from Experts</h3>
                        <p>Get direct, actionable advice from experts.</p>
                    </div>


                    <div className='landing-path-card'>
                  
                         <img src={LandingPathMeityLogo} alt='Pearson Logo' className='landing-path-logo' />
                        <h3>Build Your Dream Team</h3>
                        <p>Collaborate with peers to transform your idea.</p>
                    </div>

                    <div className='landing-path-card'>
                        <img src={bulb} alt='MeitY Logo' className='landing-path-logo' />
                        <h3>Pitch for Your Big Break</h3>
                        <p>Showcase your idea & get feedback from industry experts.</p>
                    </div>

                  

                  


                    
                    <div className='landing-path-card'>
                        <img src={LandingPathPearsonLogo} alt='Rupee Logo' className='landing-path-logo' />
                        <h3>Secure the Grant</h3>
                        <p>Win a ₹10,00,000 grant to launch your startup.</p>
                    </div>

                </div>
            </div>
        </section>


           <WhoShouldEnroll />
        <LandingPage formRef={formRef} />
            <StepOne />
            <StepTwo />
            <StepThree />
            <HowItWorks />
            <PoweredBy />
            <Timer onEnrollClick={scrollToForm} />
            <LandingInternship onEnrollClick={scrollToForm} />
       


            <LandingFAQ />
            <LandingFooter />
   </>
    );
};

export default LandingPath;
